<template>
	<div style="padding: 20px;">
		<div class="step">
			<el-steps :active="active" finish-status="success" align-center>
				<el-step title="活动信息"></el-step>
				<el-step title="活动奖励"></el-step>
				<el-step title="活动二维码"></el-step>
			</el-steps>
		</div>
		<create v-if="active == 0" ref="create" @Active="Active"></create>
		<!-- <setactivity v-if="active == 1" @previous="previous" :id="id"></setactivity> -->
	</div>
</template>
<script>
import create from "@/views/apply/newVip/marketing/activity_Douyin/create";
import reward from "@/views/apply/newVip/marketing/activity_Douyin/reward";
import setactivity from "@/views/apply/newVip/marketing/activity_Douyin/set_activity";
import { Douyin_add } from "@/api/Douyin";
import { mapGetters } from "vuex";
function randomString(e) {
	e = e || 10;
	var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz1234567890",
	  a = t.length,
		n = "";
	for (var i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
	return n;
}
export default {
	computed: {
		...mapGetters(["token", "app_id"]),
	},
	components: {
		create,
		reward,
		setactivity,
	},
	data() {
		return {
			active: 0,
			id: "",
		};
	},
	mounted() {
		this.init();
	},
	methods: {
		//初始化
		init() {},
		//下一步
		// next() {
		// 	delete this.$refs["create"].form.selectedOptions;
		// 	console.log(this.$refs["create"].form);
		// 	let data = {
		// 		...this.$refs["create"].form,
		// 		app_id: this.app_id,
		// 		nonce_str: randomString(12),
		// 	};
		// 	Douyin_add(data).then((res) => {
		// 		if (res.code == 200) {
		// 			this.id = res.data.id;
		// 			this.active++;
		// 		}
		// 	});
		// 	//
    // },
    Active(val){
      this.active = val
    },
		//上一步
		previous(val) {
			this.active = val;
		},
	},
};
</script>
<style lang="scss" scoped>
.step {
	width: 100%;
	height: 5vw;
	margin: 0 auto;
}
</style>
